<div #aladin
     id="aladin"
     style="background-color: #000;"
     [style.height.px]="height"
     [style.width.px]="width"
     (contextmenu)="onContextmenu($event)"
     (click)="onClick($event)">
</div>
